<template>
  <div class="recipes-container"  >
    <h1 class="title " style="text-align: left; font-size: calc(1rem + 2vw); color: white;  font-weight: bold " >Рецепты</h1>
    <div class="row row-cols-1 gy-4 gx-3 px-3 ps-0 pe-0" >
      <div class="col-md-12 col-sm-12 col-lg-6 height-video" >
        <div class="card h-100 shadow-lg " style= " border-radius: 0!important; border: none!important;">
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/X2EoSFPtanw?si=Sl3iEI9accQf5-kd"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer;
                 clipboard-write;
                  encrypted-media;
                   gyroscope;
                    picture-in-picture;
                     web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
      </div>
      <div class="col-md-6 col-sm-12 col-lg-3">
        <div class="card h-100 product-style" >
          <img src="/assets/recipe1.svg" class="card-img-top" style="" alt="...">
          <div class="card-body" style="width:100%; padding: 0">
            <h2 class="card-title" style=" text-align: left; font-size: calc(1rem + 0.3vw); padding-top: 1%">Рецепт "Запечённые перепёлки (для гриля и духовки)"</h2>
            <div class="recipe-button-show-container">
              <button type="button" class="btn btn-lg recipe_show_button px-2 py-2" @click="openRecipe1" style="font-size: calc(1rem + 0.5vw); width: 100%">Посмотреть</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-lg-3">
        <div class="card h-100 product-style" >
          <img src="/assets/recipe2.svg" class="card-img-top" style="" alt="...">
          <div class="card-body" style="width:100%; padding: 0">
            <h2 class="card-title" style=" text-align: left; font-size: calc(1rem + 0.3vw); padding-top: 1%">Рецепт "Апельсиновые перепёлки горячего копчения в гриле"</h2>
            <div class="recipe-button-show-container">
              <button type="button" class="btn btn-lg recipe_show_button px-2 py-2" @click="openRecipe2" style="font-size: calc(1rem + 0.5vw); width: 100%">Посмотреть</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script setup>
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue'; // Импортируйте onMounted
const router = ref(null); // Создайте ref для router
const openRecipe1 = () => {
  router.value.push('/recipes/Roasted-quail-for-grilling-and-oven').then(() => window.scrollTo(0, 0)); // Используйте router.value
};
const openRecipe2 = () => {
  router.value.push('/recipes/grilled-smoked-quail-recipe').then(() => window.scrollTo(0, 0)); // Используйте router.value
};
onMounted(() => { // Выполните код после монтирования компонента
  router.value = useRouter();
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@media (max-width: 900px) {
  .height-video{
    min-height: 50vw!important;
  }
}
.recipe-button-show-container {
  width: 100%;
  text-align: center;

  position: relative;

}
.recipe_show_button {
  height: 20%;
  border-radius: 0 !important;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  background-color: #ffffff;
  color: #ED5500FF;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  max-width: 100%;
  outline: none;
  text-align: center;
  text-decoration: none;
  vertical-align: top;
}
.recipe_show_button:hover {
  background-color: #ffffff;
  color: #ED5500FF;
  box-shadow: 0 8px 24px 0 rgba(242, 242, 242, 0.2);
}

.underline {
  text-decoration: underline;
}
.product-style{
  background-color: #F2F2F2FF;
  width: auto;
  padding: 3%;
  border-radius: 0;
  align-items: center
}
.recipes-container{
  position: relative;
  max-width: 100%;
  margin-bottom: 5%;
  min-width: 15%;
  width: auto;
}

</style>
